<template>
  <div class="wrap">
    <Nav fixed safeAreaInsetTop placeholder :title="$t('partner')" />
    <div class="content">
      <div class="content_title">
        <img class="img" src="@/assets/new/index/partner.png" alt="">
      </div>
      <div class="partner_info">
        <div class="info_item" v-for="item, index in infoList" :key="index" @click="listClick(item)">
          <img :src="item.picture && item.picture[0]" alt="">
          <!-- <div class="text">{{ item.title }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, Toast } from "vant";
import Nav from "@/components/Navbar";
import { CONTENT_SALE } from "@/api"
export default {
  components: {
    [Icon.name]: Icon,
    Nav
  },
  data() {
    return {
      infoList: []
    }
  },
  created() {
    this.getList();
  },
  methods: {
    listClick(item) {
      console.log(item);
    },
    async getList() {
      try {
        const res = await CONTENT_SALE();
        this.infoList = res.data.lists || []
      } catch (error) { }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bgImg) no-repeat;
  background-size: 100% 100%;

  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    &_title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: calc(20rem / 16) 0;

      .img {
        width: calc(75rem / 16);
        height: auto;
        display: block;
      }

      .title {
        font-size: calc(24rem / 16);
        color: var(--white);
        font-weight: 700;
      }
    }

    .partner_info {
      flex-grow: 1;
      background-color: #008f8e;
      border-radius: calc(30rem / 16) calc(30rem / 16) 0 0;
      padding: calc(10rem / 16) calc(20rem / 16);
      display: flex;
      flex-direction: column;
      row-gap: calc(20rem / 16);

      .info_item {
        display: flex;
        flex-direction: row;
        align-items: center;
        // background: #f4f4f4;
        // padding: calc(10rem / 16) calc(16rem / 16);
        // border-radius: calc(8rem / 16);

        img {
          width: 100%;
          margin-right: calc(30rem / 16);
          display: block;
        }

        .text {
          padding: calc(10rem /16) 0;
          font-size: calc(16rem / 16);
          color: var(--black);
        }
      }
    }
  }
}
</style>